"use client";

import React from "react";
import { IconSchool, IconShield, IconUsers, IconSparkles } from "@tabler/icons-react";

export default function Home(): React.JSX.Element {
  return (
    <div className="min-h-screen w-full bg-zinc-950 text-zinc-100 flex flex-col justify-between selection:bg-indigo-500 selection:text-white">
      <header className="flex h-16 w-full items-center justify-between border-b border-zinc-800/80 px-6 backdrop-blur bg-zinc-950/60 sticky top-0 z-30">
        <div className="flex items-center gap-3">
          <div className="flex h-9 w-9 items-center justify-center rounded-xl bg-indigo-600 text-white shadow-lg shadow-indigo-600/30">
            <IconSchool className="h-5 w-5" />
          </div>
          <div>
            <h1 className="text-base font-bold tracking-tight">Antigravity Whiteboard</h1>
            <p className="text-[11px] text-zinc-400 font-medium">Embedded STEM Collaborative Canvas</p>
          </div>
        </div>
      </header>

      <main className="flex-1 flex flex-col items-center justify-center px-4 py-12">
        <div className="max-w-xl w-full text-center space-y-4">
          <div className="inline-flex items-center gap-2 rounded-full border border-indigo-500/30 bg-indigo-950/40 px-3.5 py-1 text-xs font-semibold text-indigo-300 shadow-inner">
            <IconSparkles className="h-3.5 w-3.5" />
            <span>HTTP Room Lifecycle • Host-Driven Tab Governance</span>
          </div>
          <h2 className="text-3xl sm:text-4xl font-extrabold tracking-tight text-white leading-tight">
            Whiteboard Embed Service
          </h2>
          <p className="text-sm text-zinc-400 leading-relaxed">
            Mount embedded sessions via <code className="text-indigo-300">/embed/[roomId]?sessionToken=...</code> using <code className="text-indigo-300">@genieteach/whiteboard-server-sdk</code> and <code className="text-indigo-300">@genieteach/whiteboard-embed-sdk</code>.
          </p>
        </div>
      </main>

      <footer className="border-t border-zinc-800/80 py-4 px-6 text-center text-xs text-zinc-500 flex flex-wrap items-center justify-around gap-4 bg-zinc-950/80">
        <div className="flex items-center gap-2">
          <IconShield className="h-4 w-4 text-emerald-500" />
          <span>Multi-Stage Containerized Infrastructure</span>
        </div>
        <div className="flex items-center gap-2">
          <IconUsers className="h-4 w-4 text-indigo-400" />
          <span>Real-Time WebSocket Sync</span>
        </div>
        <div className="flex items-center gap-2">
          <IconSparkles className="h-4 w-4 text-amber-400" />
          <span>Pure KaTeX Vector SVG Rendering</span>
        </div>
      </footer>
    </div>
  );
}
